import React from 'react';
import { FBGridV, FBItemV } from 'react-flexbox-grid-rs';
import { View, StyleSheet, Text } from 'react-native';
import {ImageV} from 'react-native-image-vfw';
import { IconV } from 'react-icon-rs';
import Icon from 'rsuite/lib/Icon';
import BP from '../../config/default-blueprint.json';

export const LandingPageSM = () => {
    const styles = {
        bodyContainer: {
            backgroundImage: 'linear-gradient(#2a4564, #141e30)',
            justifyContent: 'center',
            alignItems: 'center',
            alignSelf: 'center',
            flexDirection: 'column',
            height: '100vh',
            width: '100%'
        },
        spinnerStyle: {
            color: '#fff',
            alignSelf: 'center',
            marginTop: 15,
        },
        imgStyle: {
            alignSelf: 'center'
        },
        titleStyle: {
            color: '#fff',
            marginTop: 15,
        }
    }
    return (
        <View style={StyleSheet.flatten([styles.bodyContainer])}>
            <ImageV
                imageStyle={{width:117, height:40, resizeMode:'contain', alignSelf:'center'}}
                source={{uri:'https://i.ibb.co/0rhNLDN/trag-logo-text.png'}}        
            />
            <Icon icon={'spinner'} spin={true} size={'2x'} style={styles.spinnerStyle} />
            <Text style={StyleSheet.flatten([styles.titleStyle])}>{BP?.verifierDetails?.blockchainVerifyingText}</Text>
        </View>
    )
}

